// Shell for every auth screen — mirrors `desktop/.../features/auth/AuthPage.tsx`
// grid layout: BrandRail on the left, centered content on the right, theme
// toggle in the top-right corner. No BackendStatusCard on web (backend status
// is a per-profile concern visible post-login).
import type { ReactNode } from "react";
import { BrandRail } from "../../components/BrandRail";
import { ThemeToggleButton } from "../../components/ThemeToggleButton";
import type { ThemeMode } from "../../lib/theme";

interface AuthLayoutProps {
	children: ReactNode;
	themeMode: ThemeMode;
	onToggleTheme: () => void;
}

export const AuthLayout = ({
	children,
	themeMode,
	onToggleTheme,
}: AuthLayoutProps) => (
	<div className="grid h-full overflow-hidden grid-cols-[minmax(260px,28vw)_minmax(0,1fr)] gap-px bg-[var(--color-tg-line)]">
		<BrandRail />
		<main className="tg-pane relative grid min-h-0 overflow-hidden px-5 py-4">
			<div className="absolute top-4 right-5 flex items-center gap-2">
				<ThemeToggleButton
					isLightTheme={themeMode === "light"}
					onToggle={onToggleTheme}
				/>
			</div>
			<div className="grid place-items-center overflow-y-auto pt-3">
				{children}
			</div>
		</main>
	</div>
);
